export const OrderTypes = {
  singleCard: 'singleCard' as 'singleCard',
  multiLine: 'multiLine' as 'multiLine',
}
